import {
  Card,
  CardHeader,
  CardBody,
  Heading,
  Text,
  Collapse,
  Flex,
} from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { useSelector } from "react-redux";
import { getFaqData } from "../../../store/faq/selectors";
import { useState } from "react";
import useFaqs from "../../../utils/hooks/useFaqs";
import AvailableSoon from "../../molecules/AvailableSoon";

export default function Home() {
  useFaqs();
  const faqs = useSelector(getFaqData);
  const [selectedFaq, setSelectedFaq] = useState<string | null>(null);

  return (
    <>
      {((faqs?.length === 0 ?? true) || !faqs?.some((faq) => faq.show)) && (
        <AvailableSoon />
      )}

      {faqs?.map(
        (faq) =>
          faq.show && (
            <Card
              mb="20px"
              boxShadow={selectedFaq === faq.question ? "md" : "none"}
              onClick={() =>
                setSelectedFaq(
                  selectedFaq === faq.question ? null : faq.question ?? "",
                )
              }
              cursor="pointer"
            >
              <CardHeader>
                <Flex justify="space-between" align="center">
                  <Heading size="base">{faq.question}</Heading>
                  {selectedFaq === faq.question ? (
                    <ChevronUpIcon boxSize={5} />
                  ) : (
                    <ChevronDownIcon boxSize={5} />
                  )}
                </Flex>
              </CardHeader>
              <Collapse in={selectedFaq === faq.question} animateOpacity>
                <CardBody>
                  <Text>{faq.answer}</Text>
                </CardBody>
              </Collapse>
            </Card>
          ),
      )}
    </>
  );
}
